<template>
    <div class="matchNum">
        <div class="item" v-for="item in data" :key="item.type_id">
            <div class="scro left">
                <p class="two">
                    <span class="def"></span>
                    <span class="color" :style="{width: parseInt(item.team1) / (parseInt(item.team1)+parseInt(item.team2)) *100+'%'}"></span>
                </p>
                <p class="one">{{item.team1}}</p>
            </div>
            <div class="name">
                {{item.type_cn_name}}
            </div>
            <div class="scro right">
                <p class="one">{{item.team2}}</p>
                <p class="two">
                    <span class="color" :style="{width: parseInt(item.team2) / (parseInt(item.team1)+parseInt(item.team2)) *100+'%'}"></span>
                    <span class="def"></span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "matchNum",
    props: ["type","data"]
}
</script>

<style lang="less" scoped>
.matchNum{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between !important;
    width: 100%;
    .item{
        border-top:1px solid #EAE9F2;
        border-left:1px solid #EAE9F2;
        width: 445px;
        height: 40px;
        background: #FFFFFF;
        display: flex;
        &:last-child{
            border-bottom:1px solid #EAE9F2;
        }
        &:nth-last-child(2){
            border-bottom:1px solid #EAE9F2;
        }
        div{
            border-right:1px solid #EAE9F2;
            line-height: 40px;
        }
        .scro{
            width: 190px;
            display: flex;
            justify-content: flex-end;
            .two{
                align-items: center;
                display: flex;
                width: 130px;
                span{
                    height: 12px;
                    background: #EAE9F2;
                }
                .def{
                    flex: 1;
                }
                .color{
                    width: 33%;
                    background: #E56262;
                }
            }
            .one{
                width: 27px;
                font-size: 13px;
                font-weight: 400;
                color: #4E5162;
                text-align: right;
                padding-right:13px ;
            }
        }
        .right{
            justify-content: flex-start;
            .color{
                background: #548FEB !important;
            }
            .one{
                
                 text-align: left;
                 padding: 0;
                padding-left:13px ;
            }
        }
        .name{
            width: 100px;
            font-size: 15px;
            font-weight: 400;
            color: #444444;
            text-align: center;
        }
    }
}
</style>